import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '@hobs/components/Loader';
import propTypes from 'prop-types';
import ErrorBoundaries from '@hobs/components/ErrorBoundaries';
import { ServiceRequestNavContext } from '@hobs/components/ServiceRequestNavContext';
import { createLoadingSelector } from '@hobs/utils/loading';
import { getConfig } from '@hobs/utils/config';
import { getExercises, getCurrentExercise } from '../../actions/exercises';
import Routes from '../../routes';
import './App.scss';

class App extends Component {
  constructor(props) {
    super(props);

    this.setServiceRequestNavigation = value => {
      this.setState({
        serviceRequestNavigation: value,
        serviceRequestId: null,
        orderId: null
      });
    };
    this.setServiceRequestId = value => {
      this.setState({
        serviceRequestId: value,
        orderId: null
      });
    };
    this.setOrderId = value => {
      this.setState({
        serviceRequestId: null,
        orderId: value
      });
    };
    this.setPreviousGridPosition = (
      dataState,
      windowScrollOffset,
      selectedAnnex,
      quickSearch,
      navigationOrigin,
      selectedUnit
    ) => {
      this.setState({
        previousGridPosition: {
          navigationOrigin,
          windowScrollOffset,
          dataState,
          selectedAnnex,
          savedQuickSearch: quickSearch,
          selectedUnit
        }
      });
    };
    this.clearSelectedAnnex = () => {
      this.setState({
        previousGridPosition: {
          selectedAnnex: null
        }
      });
    };
    this.clearSavedQuickSearch = () => {
      this.setState({
        previousGridPosition: {
          savedQuickSearch: null
        }
      });
    };
    this.clearPreviousPosition = () => {
      this.setState({
        previousGridPosition: {
          navigationOrigin: null,
          windowScrollOffset: null,
          dataState: null,
          selectedAnnex: null,
          savedQuickSearch: null,
          selectedUnit: null
        }
      });
    };
    this.clearSavedDataState = () => {
      this.setState({
        previousGridPosition: {
          ...this.state.previousGridPosition,
          dataState: null
        }
      });
    };
    this.setPreviousPageHistory = history => {
      this.setState({
        previousPageHistory: {
          ...history
        }
      });
    };
    this.setTicketNumber = value => {
      this.setState({
        ticketNumber: value
      });
    };
    this.clearSelectedUnit = () => {
      this.setState({
        previousGridPosition: {
          selectedUnit: null
        }
      });
    };

    this.state = {
      isLoading: process.env.NODE_ENV === 'production',
      serviceRequestNavigation: null,
      serviceRequestId: null,
      orderId: null,
      previousGridPosition: {
        navigationOrigin: null,
        windowScrollOffset: null,
        dataState: null,
        selectedAnnex: null,
        savedQuickSearch: null,
        selectedUnit: null
      },
      setServiceRequestNavigation: this.setServiceRequestNavigation,
      setServiceRequestId: this.setServiceRequestId,
      setOrderId: this.setOrderId,
      setPreviousGridPosition: this.setPreviousGridPosition,
      clearPreviousPosition: this.clearPreviousPosition,
      clearSelectedAnnex: this.clearSelectedAnnex,
      clearSavedQuickSearch: this.clearSavedQuickSearch,
      clearSavedDataState: this.clearSavedDataState,
      setPreviousPageHistory: this.setPreviousPageHistory,
      setTicketNumber: this.setTicketNumber,
      clearSelectedUnit: this.clearSelectedUnit
    };
  }

  async componentDidMount() {
    if (process.env.NODE_ENV === 'production') {
      const config = await getConfig();
      global.config = config;

      this.setState({
        isLoading: false
      });
    }

    if (this.props.auth.loggedIn) {
      this.onPrivatePageLoad();
    }

    window.addEventListener('keydown', this.firstTabClickEvent);
  }

  componentDidUpdate(prevProps) {
    const { loggedIn, isLoading } = this.props.auth;

    if (
      prevProps.auth.loggedIn !== loggedIn &&
      loggedIn &&
      !this.props.isExercisesLoading &&
      !isLoading
    ) {
      this.onPrivatePageLoad();
    }
  }

  // Calls this method only then user is logged in on first load/login
  onPrivatePageLoad() {
    this.props.getExercises();
    this.props.getCurrentExercise();
  }

  firstTabClickEvent = e => {
    if (e.keyCode === 9) {
      document.body.classList.add('tab-nav');

      window.removeEventListener('keydown', this.firstTabClickEvent);
      window.addEventListener('mousedown', this.firstMouseDownEvent);
    }
  };

  firstMouseDownEvent = () => {
    document.body.classList.remove('tab-nav');

    window.removeEventListener('mousedown', this.firstMouseDownEvent);
    window.addEventListener('keydown', this.firstTabClickEvent);
  };

  render() {
    const {
      auth: { loggedIn },
      isExercisesLoading,
      exercises
    } = this.props;

    if (isExercisesLoading || this.state.isLoading) {
      return (
        <div className="app-loading">
          <Loader />
        </div>
      );
    }

    if (exercises.length === 0 && loggedIn) {
      return null;
    }

    return (
      <ServiceRequestNavContext.Provider value={this.state}>
        <ErrorBoundaries>
          <Routes />
        </ErrorBoundaries>
      </ServiceRequestNavContext.Provider>
    );
  }
}

App.propTypes = {
  getExercises: propTypes.func,
  getCurrentExercise: propTypes.func,
  auth: propTypes.object,
  exercises: propTypes.array,
  isExercisesLoading: propTypes.bool
};

const exercisesLoading = createLoadingSelector(['Exercises/List']);
const mapStateToProps = state => ({
  isExercisesLoading: exercisesLoading(state),
  exercises: state.exercises.list,
  auth: state.auth
});

const mapDispatchToProps = {
  getExercises,
  getCurrentExercise
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
